module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/~/babel-runtime/core-js/symbol/iterator.js
 ** module id = 921
 ** module chunks = 0
 **/